<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-16 10:14:18
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2023-08-08 15:02:20
 * @FilePath: /bpm-form/src/components/wgForm/widget-items/wg-switch.vue
 * @Description: 描述
 -->


<template>
  <div widget-type="fileupload">
    <a-upload :fileList="text"
      :size="size"
      :data-model="fieldName"
      ref="upload"
      :name="options.name"
      :multiple="widget.options.multiple || options.multiple"
      :accept="options.accept"
      :disabled="disabled"
      :placeholder="disabled?'':placeholder"
      :action="options.action"
      :showUploadList="false"
      :class="options.customClass"
      :customRequest="handleCustomRequest"
      :listType="options.listType"
      @preview="handlePreview"
      @change="handleChange">
      <!-- :showUploadList="!disabled" -->
      <a-button v-if="!disabled && options.listType !== 'picture-card'">
        <a-icon type="upload" />{{t('wg.file.bt')}}
      </a-button>
      <!-- picture-card -->
      <div v-if="!disabled && options.listType === 'picture-card'">
        <a-icon type="plus" />
        <div class="ant-upload-text">
          {{t('wg.file.upload')}}
        </div>
      </div>
    </a-upload>
    <div>
      <uploadList
      :fileList="text" :remote="remote" :disabled="disabled" @delItem="delItem"/>
    </div>
    <div v-if="disabled && text.length === 0"
      class="disabled-text">{{t('wg.file.unupload')}}</div>
  </div>
</template>

<script>
import baseMixin from '../../lib/baseMixin';
import uploadList from './uploadList';
// customRequest 使用参考
// https://github.com/react-component/upload#customrequest

export default {
  components: {
    uploadList,
  },
  mixins: [baseMixin],
  data() {
    return {
      options: {
        accept: '.xls,.xlsx,.doc,.docx,.ppt,.pptx,.pdf,.jpg,.jpeg,.png,.gif,.zip,.rar,.7z,.eml',
        multiple: false,
        name: 'file',
        defaultValue: '[]',
        width: '',
        tip: '请上传excel、word、ppt、pdf、jpg、gif,png等格式文件',
        action: '',
        customClass: '',
        required: false,
        disabled: false,
        limit: 100,
        fileList: [],
        labelWidth: 100,
        isLabelWidth: false,
        listType: 'text', //  text, picture 和 picture-card
        hidden: false,
        dataBind: true,
        remoteFunc: '',
        remoteOption: '',
      },
    };
  },
  methods: {
    // 过滤掉val中无效的值
    initVal(val) {
      let strVal = val;
      if (val === undefined || val === '' || val === null) {
        strVal = '[]';
      }
      try {
        const value = JSON.parse(strVal);
        this.text = value.filter(item => (item.status === 'done' || !item.status)).map(item => ({
          ...item,
          uid: item.uid || item.fileId,
          name: item.name || item.originalFilename,
          status: 'done',
          url: item.url || item.downloadUrl,
          contentType: item.contentType,
          suffix: item.suffix,
          fileType: item.fileType, // 文件来源类型透传
        }));
      } catch (error) {
        this.text = [];
      }
    },
    handleCustomRequest(val) {
      this.dispatch('wgForm', 'on-upload', { type: 'fileupload', field: this.fieldName, value: val });
    },
    // 预览文件
    handlePreview(file) {
      const link = document.createElement('a');
      link.setAttribute('rel', 'noopener');
      link.setAttribute('target', '_blank');
      link.href = this.formContext.previewURL(file.url);
      setTimeout(() => {
        link.click();
      }, 0);
      return false;
    },
    delItem(index) {
      this.text.splice(index, 1)
      this.$emit('change', JSON.stringify(this.text));
    },
    // 文件上传废弃
    handleChangeSet(info) {
      const { status: fileStatus } = info.file;
      // 新增成功和删除
      if (fileStatus === 'done' || fileStatus === 'removed') {
        // 如果是删除，调用远程方法删除
        if (fileStatus === 'removed') {
          this.remote.removeFile(() => {}, info.file.uid);
        }
        const { rowIndex, fieldName: field } = this;
        const value = {
          type: 'fileupload',
          rowIndex,
          field,
          value: info,
        };
        this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
        const fileList = info.fileList.filter(item => item.status === 'done').map((item) => {
          let {
            uid, name, status, url, contentType, suffix,
          } = item;
          const { response } = item;
          if (response) {
            ({
              uid, name, status, url, contentType, suffix,
            } = response);
          }
          return {
            uid,
            name,
            status,
            url,
            contentType,
            suffix,
          };
        });
        this.$emit('change', JSON.stringify(fileList));
      } else {
        this.text = [...info.fileList];
      }
      // end
    },
    // 上传支持多文件批量上传
    handleChange(info) {
      let fileList = [...info.fileList];
      // 2. read from response and show file link
      const { rowIndex, fieldName: field } = this;
      const value = {
        type: 'fileupload',
        rowIndex,
        field,
        value: info,
      };
      this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
      fileList = fileList.map((file) => {
        let {
          uid, name, status, url, contentType, suffix,
        } = file;
        const { response } = file;
        if (response) {
          // Component will show file.url as link
          ({
            uid, name, status, url, contentType, suffix,
          } = response);
        }
        return {
          uid, name, status, url, contentType, suffix,
        };
      });
      if (fileList.filter(item => item.url).length === fileList.length) {
        this.$emit('change', JSON.stringify(fileList));
      } else {
        this.text = [...fileList];
      }
    },
    // 上传前检查文件类型
    beforeUpload(file) {
      if (this.options.listType === 'picture-card') {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
        if (!isJpgOrPng) {
          this.$message.error(this.t('wg.file.error'));
        }
        return isJpgOrPng;
      }
      return true;
    },
    // end
  },
};
</script>
